rhm.header = (function (module) {

  var settings = {
    drawer_icon: '.drawer',
    nav: '.nav__container',
    nav__link: '.nav__child .topnav__link',
    header__title: '.nav__header__title',
    nav__back: '.nav__back',
    nav__close: '.nav__close'
  };

  function qs(sel) {
    return document.querySelector(sel);
  }

  function qsa(sel) {
    return document.querySelectorAll(sel);
  }

  var clickListeners = function () {
    var drawerIcon = qs(settings.drawer_icon);
    var nav = qs(settings.nav);
    var headerTitle = qs(settings.header__title);
    var navBack = qs(settings.nav__back);
    var navClose = qs(settings.nav__close);

    if (drawerIcon && nav) {
      drawerIcon.addEventListener('click', function () {
        drawerIcon.classList.toggle('closeNav');
        document.documentElement.classList.toggle('blockScroll');
        nav.classList.toggle('nav--open');
      });
    }

    qsa(settings.nav__link).forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var activeLink = document.querySelector('.nav__item--open .topnav__link');
        qsa('.nav__item--open').forEach(function (el) {
          el.classList.remove('nav__item--open');
        });
        qsa('.childnav--open').forEach(function (el) {
          el.classList.remove('childnav--open');
        });
        if (link !== activeLink) {
          var parent = link.parentElement;
          if (parent) parent.classList.add('nav__item--open');
          if (nav) nav.classList.add('childnav--open');
          if (headerTitle) {
            var track = link.getAttribute('data-track');
            headerTitle.textContent = track || '';
          }
          if (nav && !nav.classList.contains('nav--open')) {
            nav.classList.add('nav--open');
          }
        } else if (navClose) {
          navClose.click();
        }
      });
    });

    if (navBack && headerTitle) {
      navBack.addEventListener('click', function () {
        qsa('.nav__item--open').forEach(function (el) {
          el.classList.remove('nav__item--open');
        });
        if (nav) nav.classList.remove('childnav--open');
        headerTitle.textContent = 'blakshop';
      });
    }

    if (navClose && drawerIcon && nav && headerTitle) {
      navClose.addEventListener('click', function () {
        qsa('.nav__item--open').forEach(function (el) {
          el.classList.remove('nav__item--open');
        });
        document.documentElement.classList.remove('blockScroll');
        headerTitle.textContent = 'blakshop';
        drawerIcon.classList.remove('closeNav');
        nav.classList.remove('childnav--open');
        nav.classList.remove('nav--open');
      });
    }
  };

  var init = function () {
    clickListeners();
  };

  module = {
    init: init
  };

  return module;

}(rhm.header));
